import { motion } from "framer-motion";

export const Mission = () => {
  return (
    <section
      id="mission"
      data-testid="mission-section"
      className="relative bg-[#F9F8F6] py-24 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-6 md:gap-12">
        {/* Number + label */}
        <div className="col-span-12 md:col-span-2">
          <p className="text-[13px] md:text-sm uppercase tracking-[0.28em] text-[#5C665F] font-semibold mb-2">
            The Mission
          </p>
          <motion.span
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="font-serif-display text-[100px] md:text-[140px] lg:text-[180px] leading-none text-[#E8E3DA] font-light block"
          >
            01
          </motion.span>
        </div>

        {/* Heading + body */}
        <div className="col-span-12 md:col-span-6 md:pt-4">
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1 }}
            data-testid="mission-heading"
            className="font-serif-display text-[#2D3730] text-4xl sm:text-5xl lg:text-[60px] leading-[1.1] font-light tracking-tight"
          >
            To empower fathers with the emotional intelligence, tools, and{" "}
            <span className="italic text-[#C06E52]">a community</span> they need to
            actively support their children&rsquo;s emotional growth.
          </motion.h2>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, delay: 0.2 }}
            className="mt-12 md:mt-16 grid sm:grid-cols-2 gap-10 md:gap-14"
          >
            <div>
              <p className="text-[12px] uppercase tracking-[0.22em] text-[#C06E52] mb-3">
                Beyond the provider
              </p>
              <p className="text-[#5C665F] text-base md:text-lg leading-relaxed font-light">
                Fatherhood is more than what you put on the table. It is what you put
                into a small, watching heart &mdash; patience, language for feelings,
                a steady gaze that says{" "}
                <em className="not-italic font-serif-display italic text-[#C06E52] text-xl md:text-2xl font-medium">you matter</em>.
              </p>
            </div>
            <div>
              <p className="text-[12px] uppercase tracking-[0.22em] text-[#C06E52] mb-3">
                From intention to action
              </p>
              <p className="text-[#5C665F] text-base md:text-lg leading-relaxed font-light">
                Most fathers love deeply. Few were given the tools. We close that gap
                with emotional skills, daily rituals, and a brotherhood that walks the
                path with you.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Image */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.1, delay: 0.1 }}
          className="col-span-12 md:col-span-4 flex md:justify-end md:items-start"
        >
          <div className="relative w-full aspect-square overflow-hidden bg-black">
            <img
              src="https://customer-assets.emergentagent.com/job_vision-driven/artifacts/h2p2u3ka_image.png"
              alt="A father at the center of emotional skills — self awareness, mindfulness, strong connection, resilience, growth mindset, emotional regulation, and effective communication"
              className="absolute inset-0 w-full h-full object-contain"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
